//QC Stages
// export const GET_QC_STAGE = "GET_QC_STAGE";

//Accounts-Master Compliance Item

// export const GET_COMPILANCE_ITEM = "GET_COMPILANCE_ITEM";
// export const GET_COMPLIANCE_ITEM_FILTER_COMPLIANCE_NAME =
//   "GET_COMPLIANCE_ITEM_FILTER_COMPLIANCE_NAME";

// Audit Master
export const GET_AUDIT_PROCESS = "GET_AUDIT_PROCESS";
export const GET_AUDIT_PROCESS_FILTER_DEPARTMENT = "GET_AUDIT_PROCESS_FILTER_DEPARTMENT";
export const GET_AUDIT_PROCESS_DETAIL = "GET_AUDIT_PROCESS_DETAIL";
export const GET_PROCESS_DOCUMENTS = "GET_PROCESS_DOCUMENTS";
export const GET_PROCESS_DOCUMENTS_DETAIL = "GET_PROCESS_DOCUMENTS_DETAIL";
export const GET_PROCESS_DOCUMENTS_FILTER_DEPARTMENT = "GET_PROCESS_DOCUMENTS_FILTER_DEPARTMENT";
export const GET_PROCESS_CHECK_POINT_OPTION = "GET_PROCESS_CHECK_POINT_OPTION";
export const GET_PROCESS_CHECK_POINT = "GET_PROCESS_CHECK_POINT";
export const GET_PROCESS_CHECK_POINT_FILTER_PROCESS = "GET_PROCESS_CHECK_POINT_FILTER_PROCESS";
export const GET_PROCESS_CHECK_POINT_DETAIL = "GET_PROCESS_CHECK_POINT_DETAIL";
export const GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT =
  "GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT";

// Audit Schedule(SVM)

export const GET_AUDIT_SCHEDULE = "GET_AUDIT_SCHEDULE";
export const GET_AUDIT_SCHEDULE_FILTER_PROCESS = "GET_AUDIT_SCHEDULE_FILTER_PROCESS";
export const GET_AUDIT_SCHEDULE_FILTER_DEPARTMENT = "GET_AUDIT_SCHEDULE_FILTER_DEPARTMENT";
export const GET_AUDIT_SCHEDULE_DETAIL = "GET_AUDIT_SCHEDULE_DETAIL";
export const GET_AUDIT_SCHEDULE_PRINT = "GET_AUDIT_SCHEDULE_PRINT";

// Audit Calendar
export const GET_AUDIT_CALENDAR = "GET_AUDIT_CALENDAR";
export const GET_AUDIT_CALENDAR_FILTER_DEPARTMENT = "GET_AUDIT_CALENDAR_FILTER_DEPARTMENT";
export const GET_AUDIT_CALENDAR_FILTER_PROCESS = "GET_AUDIT_CALENDAR_FILTER_PROCESS";
export const GET_AUDIT_CALENDAR_FILTER_STATUS = "GET_AUDIT_CALENDAR_FILTER_STATUS";

// Audit Observation
export const GET_AUDIT_SCHEDULE_OBSERVATION = "GET_AUDIT_SCHEDULE_OBSERVATION";
export const GET_AUDIT_SCHEDULE_OBSERVATION_EXPORT = "GET_AUDIT_SCHEDULE_OBSERVATION_EXPORT";
export const GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPARTMENT =
  "GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPsARTMENT";
export const GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS =
  "GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS";
export const GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_ASSIGNED_TO =
  "GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_ASSIGNED_TO";
export const GET_AUDIT_SCHEDULE_OBSERVATION_DETAIL = "GET_AUDIT_SCHEDULE_OBSERVATION_DETAIL";
export const GET_PROCESS_CHECK_POINT_EXPORT = "GET_PROCESS_CHECK_POINT_EXPORT";
export const GET_AUDIT_SCHEDULE_EXPORT = "GET_AUDIT_SCHEDULE_EXPORT";
export const GET_AUDIT_CALENDAR_EXPORT = "GET_AUDIT_CALENDAR_EXPORT";
export const GET_AUDIT_PROCESS_EXPORT = "GET_AUDIT_PROCESS_EXPORT";
export const GET_PROCESS_CHECK_POINT_OPTION_EXPORT = "GET_PROCESS_CHECK_POINT_OPTION_EXPORT";

// Check point template
export const AUDIT_CHECK_POINT_TEMPLATE = "AUDIT_CHECK_POINT_TEMPLATE";
export const AUDIT_OBSERVATION_TEMPLATE = "AUDIT_OBSERVATION_TEMPLATE";
export const GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DATE =
  "GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DATE";
export const GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPARTMENT_TEMPLATE =
  "GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_DEPARTMENT_TEMPLATE";
export const GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS_TEMPLATE =
  "GET_AUDIT_SCHEDULE_OBSERVATION_FILTER_PROCESS_TEMPLATE";
export const GET_PROCESS_CHECK_POINT_FILTER_PROCESS_TEMPLATE =
  "GET_PROCESS_CHECK_POINT_FILTER_PROCESS_TEMPLATE";
export const GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT_TEMPLATE =
  "GET_PROCESS_CHECK_POINT_FILTER_DEPARTMENT_TEMPLATE";
export const GET_PROCESS_CHECK_POINT_FILTER_OCCURENCE = "GET_PROCESS_CHECK_POINT_FILTER_OCCURENCE";
